import React from 'react';

const dayNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

function formatHour(hour) {
  if (hour === 0 || hour === 24) return '12 AM';
  if (hour === 12) return '12 PM';
  if (hour < 12) return `${hour} AM`;
  return `${hour - 12} PM`;
}

export default function PeakAnalysisCard({ peaks }) {
  if (!peaks) return null;

  const { bestDayOfWeek, bestHourOfDay, dayOfWeekDistribution, hourDistribution } = peaks;
  const maxDayValue = Math.max(...(dayOfWeekDistribution || []), 1);

  return (
    <div className="bg-white rounded-lg shadow p-5">
      <h4 className="text-base font-semibold text-gray-900">Peak Analysis</h4>
      <p className="mt-1 text-sm text-gray-500">When your listing gets the most activity</p>

      <div className="mt-4 grid grid-cols-2 gap-4">
        <div className="bg-gray-50 rounded-lg p-4 text-center">
          <p className="text-xs font-medium text-gray-500 uppercase">Best Day</p>
          <p className="mt-1 text-2xl font-bold text-gray-900">
            {bestDayOfWeek != null ? dayNames[bestDayOfWeek] : '--'}
          </p>
        </div>
        <div className="bg-gray-50 rounded-lg p-4 text-center">
          <p className="text-xs font-medium text-gray-500 uppercase">Best Hour</p>
          <p className="mt-1 text-2xl font-bold text-gray-900">
            {bestHourOfDay != null ? formatHour(bestHourOfDay) : '--'}
          </p>
        </div>
      </div>

      {dayOfWeekDistribution && dayOfWeekDistribution.length > 0 && (
        <div className="mt-6">
          <p className="text-xs font-medium text-gray-500 uppercase mb-3">Activity by Day</p>
          <div className="flex items-end gap-1" style={{ height: 80 }}>
            {dayOfWeekDistribution.map((value, i) => (
              <div key={i} className="flex-1 flex flex-col items-center">
                <div
                  className="w-full rounded-t bg-primary/80"
                  style={{
                    height: `${(value / maxDayValue) * 100}%`,
                    minHeight: value > 0 ? 4 : 0,
                  }}
                />
                <span className="mt-1 text-xs text-gray-500">{dayNames[i]}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
